
@if (loadingRecords) {
  <div class="d-flex justify-content-center loader">
    <div class="loader-container" style="text-align: center;">
      <div class="spinner-border"></div>
      <div>
        <p>Loading Data...</p>
      </div>
    </div>
  </div>
}

<table class="advanced-report-template-table">
  <thead>
    @if (tableHeaders && tableHeaders.columns) {
      <tr class="header-row">
        @for (header of tableHeaders.columns; track header) {
          <th class="table-header" [sortable]="header.column" (sort)="onSort($event)">
            <div class="column-wrapper">
              <div class="header-name">
                <span>
                  {{ header.column.replace('_', '') }}
                </span>
                @if (sortEvent && sortEvent.column === header.column) {
                  <span class="sort-indicator">
                    @switch (sortEvent.direction) {
                      @case ('asc') {
                        <p>
                          ↑
                        </p>
                      }
                      @case ('desc') {
                        <p>
                          ↓
                        </p>
                      }
                    }
                  </span>
                }
              </div>
            </div>
          </th>
        }
      </tr>
    }
  </thead>
  <tbody>
    @for (row of data; track row) {
      <tr class="table-row" (click)="onRowClick(row)">
        @for (header of tableHeaders.columns; track header) {
          <td class="table-column" [ngStyle]="getStyles(header)">
            {{ row[header.column] }}
          </td>
        }
      </tr>
    }
    @if (!data || data.length === 0) {
      <tr>
        <td class="no-data-found" colspan="100">{{ errorText ? errorText : 'No Data Found' }}</td>
      </tr>
    }
  </tbody>
</table>
